import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { ShareLink } from 'app/entities/share-link';
import { SettingsService } from 'app/main/pages/settings/settings.service';
import { GtagService } from 'app/services/gtag.service';
import { SubscriptionRestrictionService } from 'app/services/subscription-restriction.service';
import { take } from 'rxjs/operators';
import { QuotesDatasource } from './quotes-datasource';
import { QuotesService } from './quotes.service';
import { PreviewQuoteComponent } from '../preview-quote/preview-quote.component';
import { Quote } from 'app/entities/quote';

@Component({
  selector: 'app-quote-list',
  templateUrl: './quote-list.component.html',
  styleUrls: ['./quote-list.component.scss'],
  animations: fuseAnimations,
})
export class QuoteListComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  dataSource!: QuotesDatasource;
  @Input('showClient') showClient = true;
  @Input('pageSize') pageSize = null;

  displayedColumns = ['details', 'requested_at', 'acoes'];

  showTable = true;
  @Output() hasQuotesChange = new EventEmitter<boolean>();
  hasQuotes = false;

  defaultShareLink?: ShareLink | null;
  copiedLink = false;

  constructor(
    private _quotesService: QuotesService,
    public _matDialog: MatDialog,
    private _router: Router,
    private _subscriptionRestrictionService: SubscriptionRestrictionService,
    private _gtag: GtagService,
    private _cdr: ChangeDetectorRef,
    private _settingsService: SettingsService,
  ) {}

  ngOnInit() {
    this.dataSource = new QuotesDatasource(this._quotesService);

    this.dataSource.noRecords.pipe(take(2)).subscribe((res) => {
      if (res) {
        this.showTable = false;
      }
      this.hasQuotes = !res;
      this.hasQuotesChange.emit(this.hasQuotes);
      this._cdr.detectChanges();
    });

    this.loadDefaultShareLink();
  }

  private loadDefaultShareLink(): void {
    this._settingsService.getShareLinks().subscribe({
      next: (links) => {
        this.defaultShareLink = (links || []).find((link) => link.isDefault && link.isActive) || null;
      },
      error: () => {
        this.defaultShareLink = null;
      }
    });
  }

  openSettings(): void {
    this._router.navigate(['/configuracao/minha-pagina']);
  }

  copyShareLink(): void {
    if (this.defaultShareLink?.pageLink) {
      navigator.clipboard.writeText(this.defaultShareLink.pageLink).then(() => {
        this.copiedLink = true;
        setTimeout(() => { this.copiedLink = false; }, 2000);
      });
    }
  }

  onTableUpdate(params: any) {
    this.dataSource?.load(params);
  }

  onSelectedRow(item: Quote) {
    let dialog = this._matDialog.open(PreviewQuoteComponent, {
      panelClass: ['form-dialog', 'big-radius-dialog', 'quote-preview-dialog'],
      width: '700px',
      maxWidth: '95vw',
      data: {
        quote: item,
      },
    });
    dialog.afterClosed().subscribe((result) => {});
  }
}
